<template>
  <div
    v-analytics.pageview="'end'"
    class="page page-end"
  >
    <b-notification
      v-if="$previewCode"
      type="is-warning"
      aria-close-label="Close notification"
      role="alert"
      class="preview-alert"
    >
      当前为预览页面，答案不被记录
    </b-notification>
    <div class="end">
      <rich-text
        v-if="surveyData.conclusion"
        :html="surveyData.conclusion"
      />
      <div class="end-action">
        <!--      <b-button type="is-primary" class="end-btn">-->
        <!--        {{$t('view_the_answer')}}-->
        <!--      </b-button>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import lottery from '@/components/lottery';

export default {
  name: 'End',

  computed: {
    ...mapState(['surveyData', 'configs']),
  },

  created() {
    if (this.configs.amsLottery) {
      lottery({
        // eslint-disable-next-line no-underscore-dangle
        sid: this.surveyData._id,
      });
    }
  },

  methods: {
  },
};
</script>

<style lang="scss">
.page-end {
  padding-bottom: 260px / $px;
  font-size: $descSize;
  line-height: $descLineHeight;
  min-height: 100vh;
  @include desktop {
    padding-bottom: 0;
  }
  @include landscape {
    padding-bottom: 0;
  }
}

.end {
  padding: $padding * 2 $padding;
  @include desktop {
    width: $desktopWidth;
    padding: $desktopPadding;
    margin: 0 auto;
  }
  @include landscape {
    padding: $landscapePadding;
    margin: 0 auto;
  }
  &-action {
    margin-top: 60px / $px;
    padding: 0 $normalGap;
  }
  &-btn {
    min-width: 100%;
    @include desktop {
      min-width: 220px;
      margin: 78px auto 0;
    }
    @include landscape {
      min-width: 220px;
      margin: 78px / $px auto 0;
    }
  }
}

.preview-alert{
  position: relative;
  margin: 0!important;
  border-radius: 0 !important;
}
</style>
